import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MonEntrepriseFormComponent } from './mon-entreprise-form/mon-entreprise-form.component';
import { SignUpStoreService } from '../../../services/sign-up-store/sign-up-store.service';
import { SignUpCompanyData } from '../interfaces/sign-up-store.interface';
import { SiretService } from '../../../services/siret/siret.service';
import { Siret } from '../../../models/siret.model';
import { PLoaderComponent } from '../../../../shared/design-system/atoms/p-loader/p-loader.component';
import { CommonModule } from '@angular/common';
import { StepperNavigationHelperService } from '../../../../shared/services/behavior/stepper-navigation-helper.service';
import {
  ErrorState,
  ErrorStateService,
} from '../../../../rapport/state/error-state.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-mon-entreprise',
  standalone: true,
  imports: [MonEntrepriseFormComponent, PLoaderComponent, CommonModule],
  templateUrl: './mon-entreprise.component.html',
  styleUrl: './mon-entreprise.component.scss',
})
export class MonEntrepriseComponent implements OnInit, OnDestroy {
  private readonly signUpStoreService = inject(SignUpStoreService);
  private readonly siretService = inject(SiretService);
  private readonly stepperNavigationHelperService = inject(
    StepperNavigationHelperService,
  );
  private readonly errorStateService = inject(ErrorStateService);
  private readonly destroy$ = new Subject<void>();

  company: SignUpCompanyData = this.signUpStoreService.getCompanySnapshot();
  siret?: Siret | null;
  isLoading = false;
  errorMessage: string | null = null;
  errorStatus: number | null = null;

  ngOnInit(): void {
    this.errorStateService.errorState$
      .pipe(takeUntil(this.destroy$))
      .subscribe((errorState: ErrorState) => {
        this.errorMessage = errorState.message;
        this.errorStatus = errorState.status;
      });
  }

  ngOnDestroy(): void {
    this.errorStateService.clearError();
    this.destroy$.next();
    this.destroy$.complete();
  }

  public onCompanyChanged(company: SignUpCompanyData): void {
    this.company = company;
    this.signUpStoreService.patchCompany(company);
  }

  public async onVerifySiret(value: string) {
    this.isLoading = true;
    try {
      this.siret = await this.siretService.verifySiret(value);
    } finally {
      this.isLoading = false;
    }
  }

  public onDisableNextButton(disable: boolean) {
    this.stepperNavigationHelperService.emitDisableGoToStep(disable);
  }

  public onNotificationClick(): void {
    if (!this.isLoading && this.errorStatus != 404) {
      this.errorStateService.clearError();
    }
  }

  public onCleanSiretError() {
    if (this.errorStatus && this.errorMessage) {
      this.errorStateService.clearError();
    }
  }
}
